<template>
  <div class="404-page page-error">
    <EmptyState
      :confirm-action="redirect"
      illustration="403-Version2"
      title="Ops! Parece que você não tem permissão para acessar esta página"
      subtitle="Contate a pessoa que administra sua conta para obter maiores detalhes. Enquanto isso, você pode continuar navegando e voltar para o início."
      confirm-action-text="Voltar para o início"
    />
  </div>
</template>

<script>
import EmptyState from '@/components/harvest/ui/emptyState/EmptyState.vue';
export default {
  components: {
    EmptyState
  },
  methods: {
    redirect() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.page-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 80px);
  text-align: center;
}
</style>
